import { MESSAGE_STATUSES } from '../constants';

export const getIsConversationFinished = (status) =>
  [
    MESSAGE_STATUSES.ROBOT_FOUND,
    MESSAGE_STATUSES.ABORTED,
    MESSAGE_STATUSES.ESCALATED,
  ].includes(status);
